module.exports = __webpack_public_path__ + "img/28-12_checho_ramirez_thumb.f8146566.jpg";